import { parsePhoneNumberFromString } from 'libphonenumber-js'

/**
 * A stored phone number the way people dial it (USA-1473): US and Canada as (800) 875-3381 ext. 215,
 * everyone else with their country code, +41 61 123 45 67. Anything that is not a dialable number is
 * shown as stored.
 */
export function formatPhone(raw: string): string {
  const parsed = parsePhoneNumberFromString(raw, 'US')
  if (!parsed?.isPossible()) return raw.trim()
  return parsed.countryCallingCode === '1' ? parsed.formatNational() : parsed.formatInternational()
}

/** A tel: link for a stored phone number, or null when it is not a dialable number. */
export function phoneHref(raw: string): string | null {
  const parsed = parsePhoneNumberFromString(raw, 'US')
  return parsed?.isPossible() ? parsed.getURI() : null
}
